import { createContext } from 'react';
import EventLog from '@tv2/lib-core/logging/eventLogger';

export const LoggingContext = createContext<EventLog | null>(null);
